export default function LobsterMascot({ size = 120, className, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Claw-dius friendly lobster mascot"
      role="img"
      className={className}
      style={style}
    >
      {/* Tail fan */}
      <ellipse cx="60" cy="107" rx="11" ry="5" fill="#cc3311" />
      <ellipse cx="46" cy="110" rx="8" ry="4" fill="#cc3311" transform="rotate(-28 46 110)" />
      <ellipse cx="74" cy="110" rx="8" ry="4" fill="#cc3311" transform="rotate(28 74 110)" />

      {/* Body segments */}
      <ellipse cx="60" cy="94" rx="16" ry="9" fill="#dd4422" />
      <ellipse cx="60" cy="81" rx="19" ry="11" fill="#e05530" />

      {/* Segment ridges */}
      <path d="M44 75 Q60 79 76 75" stroke="#c03010" strokeWidth="1.2" fill="none" opacity="0.7" />
      <path d="M43 87 Q60 91 77 87" stroke="#c03010" strokeWidth="1.2" fill="none" opacity="0.7" />

      {/* Thorax / carapace */}
      <ellipse cx="60" cy="64" rx="22" ry="19" fill="#e86040" />

      {/* Walking legs (3 pairs) */}
      <line x1="44" y1="73" x2="31" y2="86" stroke="#dd4422" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="42" y1="81" x2="29" y2="93" stroke="#dd4422" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="44" y1="88" x2="33" y2="100" stroke="#dd4422" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="76" y1="73" x2="89" y2="86" stroke="#dd4422" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="78" y1="81" x2="91" y2="93" stroke="#dd4422" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="76" y1="88" x2="87" y2="100" stroke="#dd4422" strokeWidth="2.5" strokeLinecap="round" />

      {/* Left claw arm */}
      <path d="M40 61 Q28 53 20 59 Q12 65 16 73 Q20 81 30 79 Q40 77 42 67 Z" fill="#e05530" />
      {/* Left claw upper finger */}
      <path d="M17 62 Q9 54 12 48 Q16 43 22 49" fill="#c04020" />
      {/* Left claw lower finger */}
      <path d="M17 67 Q7 67 8 74 Q8 81 17 79" fill="#c04020" />

      {/* Right claw arm */}
      <path d="M80 61 Q92 53 100 59 Q108 65 104 73 Q100 81 90 79 Q80 77 78 67 Z" fill="#e05530" />
      {/* Right claw upper finger */}
      <path d="M103 62 Q111 54 108 48 Q104 43 98 49" fill="#c04020" />
      {/* Right claw lower finger */}
      <path d="M103 67 Q113 67 112 74 Q112 81 103 79" fill="#c04020" />

      {/* Head */}
      <ellipse cx="60" cy="40" rx="21" ry="19" fill="#f07050" />

      {/* Rostrum (pointy top) */}
      <polygon points="60,18 55,28 65,28" fill="#e86040" />

      {/* Antennae (long, curving outward) — behind eyes */}
      <path d="M52 21 C46 13 38 8 30 2" stroke="#dd4422" strokeWidth="2.5" strokeLinecap="round" fill="none" />
      <path d="M68 21 C74 13 82 8 90 2" stroke="#dd4422" strokeWidth="2.5" strokeLinecap="round" fill="none" />

      {/* Antennules (short) — behind eyes */}
      <path d="M52 23 C47 17 43 13 40 9" stroke="#dd4422" strokeWidth="1.5" strokeLinecap="round" fill="none" />
      <path d="M68 23 C73 17 77 13 80 9" stroke="#dd4422" strokeWidth="1.5" strokeLinecap="round" fill="none" />

      {/* Eye stalks — behind eyes */}
      <rect x="49" y="20" width="3.5" height="18" rx="1.75" fill="#dd4422" />
      <rect x="67.5" y="20" width="3.5" height="18" rx="1.75" fill="#dd4422" />

      {/* Eyes (sclera, iris, pupil, sparkle) — drawn last so they sit on top of stalks/antennae */}
      <circle cx="50.75" cy="20" r="8" fill="white" />
      <circle cx="69.25" cy="20" r="8" fill="white" />
      <circle cx="51" cy="20" r="5" fill="#2288cc" />
      <circle cx="69" cy="20" r="5" fill="#2288cc" />
      <circle cx="51.5" cy="20" r="2.8" fill="#111" />
      <circle cx="69.5" cy="20" r="2.8" fill="#111" />
      <circle cx="52.5" cy="18.5" r="1.2" fill="white" />
      <circle cx="70.5" cy="18.5" r="1.2" fill="white" />

      {/* Rosy cheeks */}
      <circle cx="44" cy="47" r="8" fill="#ff9977" opacity="0.4" />
      <circle cx="76" cy="47" r="8" fill="#ff9977" opacity="0.4" />

      {/* Smile */}
      {/* White teeth fill */}
      <path d="M45 46 C52 59 68 59 75 46" fill="white" opacity="0.95" />
      {/* Upper lip overlay (shows just the gum line) */}
      <path d="M45 46 C52 49 68 49 75 46" fill="#c04030" />
      {/* Smile outline */}
      <path d="M45 46 C52 59 68 59 75 46" stroke="#c04030" strokeWidth="2" fill="none" />
    </svg>
  );
}
